import React from 'react'
import {Col} from 'react-bootstrap'
import {getExperienceDate} from '../helpers/getExperienceDate'

const ExperienceCard = ({data}) => {

    const firstRole = data.roles[0]
    const lastRole = data.roles[data.roles.length - 1]

    const totalExperience = getExperienceDate(
        firstRole.startDate,
        lastRole.endDate
    )

    const roles = [...data.roles]

    return (
        <Col lg="8" className="mb-5 text-center">

            <a href={data.companyUrl} target="_blank" rel="noopener noreferrer">
                <img
                    alt={`${data.companyName} Logo`}
                    className="bg-white mb-3"
                    src={data.companyLogo}
                />
            </a>

            <h4>{data.companyName}</h4>
            <p className="mb-4">
                <strong>{totalExperience.duration}</strong>
            </p>

            {roles.map((item, index) => {

                const {formattedStart, formattedEnd, duration} =
                    getExperienceDate(item.startDate, item.endDate)

                return (
                    <div key={index} className="mb-3">

                        <p className="lead mb-1">
                            <strong>{item.role}</strong>
                        </p>

                        <p className="text-muted mb-1">
                            {formattedStart} – {formattedEnd}
                        </p>

                        <p className="text-muted small mb-0">
                            {duration}
                        </p>

                        {index < roles.length - 1 && (
                            <div className="role-arrow">
                                ↓
                            </div>
                        )}

                    </div>
                )
            })}

        </Col>
    )
}

export default ExperienceCard